// extracted by mini-css-extract-plugin
export default {"priceInput":"price-input--priceInput--cd1670","currencySuffix":"price-input--currencySuffix--e0f16e"};